<template>
  <div>
    <gc-order-detail-buttons-base
      :order-detail="orderDetail"
      :show-customer-goods-btn="showCustomerGoodsBtn"
      :show-invoice-btn="showInvoiceBtn"
      @goToCustomerGoods="goToCustomerGoods"
      @goToInvoice="goToInvoice"
    ></gc-order-detail-buttons-base>
  </div>
</template>

<script>
import GcOrderDetailButtonsBase from './components/GcOrderDetailButtonsBase.vue'
import EMKT from '../../constant'

export default {
  name: 'GcOrderCommonButtons',
  components: { GcOrderDetailButtonsBase },
  props: {
    orderDetail: Object
  },
  computed: {
    showCustomerGoodsBtn () {
      return EMKT.showProgressBtn(this.orderDetail) && !EMKT.isGVAPContract(this.orderDetail)
    },
    showInvoiceBtn () {
      return EMKT.showProgressBtn(this.orderDetail)
    }
  },
  methods: {
    getOrderStatusText: EMKT.getOrderStatusText,
    // 处理路由跳转逻辑
    goToInvoice () {
      this.$router.push({ name: 'WeappGcOrderInvoiceDetail', params: { orderNo: this.orderDetail.orderNo } })
    },
    goToCustomerGoods () {
      console.log('goToCustomerGoods======>', this.orderDetail.itemList)
      let contractNos = this.orderDetail.itemList.map(obj => { return obj.contractNo }).join(',')
      this.$router.push({ name: 'WeappGcOrderGoodsDetail', params: { contractNos: contractNos } })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// GcOrderDetailButtonsWithActions.vue?11ceea09